import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { UI_CONSTANTS } from "../../utils/constants";
import { useLanguage } from "../../context/LanguageContext";
import { getLocalizedFieldValue } from "../../utils/language";

// Constant scroll speed in pixels per second, independent of item count or viewport.
const TICKER_PX_PER_SECOND = 160;
const DEFAULT_TICKER_DURATION = 40;

const Ticker = () => {
  const [winTickets, setWinTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [duration, setDuration] = useState(DEFAULT_TICKER_DURATION);
  const trackRef = useRef(null);
  const { language } = useLanguage();

  const normalizeWinTicketData = (data) => {
    if (!data) return [];
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.winTickets)) return data.winTickets;
    if (Array.isArray(data?.winTicket)) return data.winTicket;
    if (Array.isArray(data)) return data;
    return [];
  };

  const fetchWinTickets = useCallback(async () => {
    setLoading(true);
    try {
      const response = await handleApiCall("get", endpoints.winTicketList);
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true ||
        response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS
      ) {
        const responseData = response?.data?.data;
        setWinTickets(normalizeWinTicketData(responseData));
      } else if (response?.error) {
        console.error("Error fetching win tickets:", response?.message);
        setWinTickets([]);
      } else {
        setWinTickets([]);
      }
    } catch (error) {
      console.error("Error fetching win tickets:", error);
      setWinTickets([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWinTickets();
  }, [fetchWinTickets]);

  // The keyframes translate the track by 50% (one copy of the items), so the
  // duration must scale with the track width to keep a constant px/s speed.
  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;

    const updateDuration = () => {
      const oneCopyWidth = el.scrollWidth / 2;
      if (!oneCopyWidth) return;
      setDuration(Math.max(oneCopyWidth / TICKER_PX_PER_SECOND, 1));
    };

    updateDuration();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateDuration);
      return () => window.removeEventListener("resize", updateDuration);
    }

    const observer = new ResizeObserver(updateDuration);
    observer.observe(el);
    return () => observer.disconnect();
  }, [winTickets, language, loading]);

  const renderTickerItems = () => {
    if (loading) {
      return (
        <span className="flex items-center">
          {UI_CONSTANTS.BUTTON_LABELS.LOADING || "Loading..."}
        </span>
      );
    }

    if (!winTickets.length) {
      return (
        <span className="flex items-center">
          {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
        </span>
      );
    }

    // return winTickets.map((item, index) => {
    //   const title =
    //     getLocalizedFieldValue(item, language, "title") ||
    //     UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND;
    //   // const link = item.link || item.url || "";
    //   const link = language === "AR"
    //         ? item.link_ar || item.link || item.url || ""
    //         : item.link || item.url || "";
    //   const linkText =
    //     getLocalizedFieldValue(item, language, "linkText") ||
    //     item.linkText ||
    //     (language === "AR" ? "اشترك الآن" : UI_CONSTANTS.BUTTON_LABELS.ENTER_NOW) ||
    //     "اشترك الآن";

    //   return (
    //     <span key={item._id || item.id || index} className="flex items-start mr-14">
    //       {title}
    //       {link ? (
    //         <Link
    //           to={link}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           className="font-SaudiaRegularItalic text-[22px] lg:mt-2.5 mx-5"
    //         >
    //           {linkText}
    //         </Link>
    //       ) : (
    //         <span className="font-SaudiaRegularItalic text-[22px] lg:mt-2.5 mx-5 opacity-70">
    //           {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
    //         </span>
    //       )}
    //     </span>
    //   );
    // });
  return winTickets.map((item, index) => {
  const title =
    getLocalizedFieldValue(item, language, "title") ||
    UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND;

  const link =
    language === "AR"
      ? item.link_ar || item.link || item.url || ""
      : item.link || item.url || "";

  // const linkText =
  //   getLocalizedFieldValue(item, language, "linkText") ||
  //   item.linkText ||
  //   (language === "AR" ? "اشترك الآن" : UI_CONSTANTS.BUTTON_LABELS.ENTER_NOW);

  const linkText =
  language === "AR"
    ? item.button_text_ar ||
      getLocalizedFieldValue(item, language, "linkText") ||
      "اشترك الآن"
    : item.button_text_en ||
      getLocalizedFieldValue(item, language, "linkText") ||
      UI_CONSTANTS.BUTTON_LABELS.ENTER_NOW;


  const Content = (
    <span className="flex items-start mr-14 cursor-pointer">
      <span>{title}</span>
      <span className="font-SaudiaRegularItalic text-[22px] lg:mt-2.5 mx-5">
        {linkText}
      </span>
    </span>
  );

  return link ? (
    <Link
      key={item._id || item.id || index}
      to={link}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:opacity-90 transition-opacity"
    >
      {Content}
    </Link>
  ) : (
    <span
      key={item._id || item.id || index}
      className="flex items-start mr-14 opacity-70"
    >
      {title}
    </span>
  );
});

  };

  return (
    <div
      className="group flex w-full overflow-hidden font-SaudiaExtraBold text-3xl md:text-[30px] lg:text-[42px] text-white my-14 pt-[6px]"
      dir="ltr"
    >
      <div
        ref={trackRef}
        style={{ animationDuration: `${duration}s` }}
        className={`flex w-max will-change-transform group-hover:[animation-play-state:paused] motion-reduce:[animation-play-state:paused] ${
          language === "AR" ? "animate-ticker-right" : "animate-ticker-left"
        }`}
      >
        <div className="flex min-w-[100vw] shrink-0">
          {renderTickerItems()}
        </div>
        <div className="flex min-w-[100vw] shrink-0" aria-hidden="true">
          {renderTickerItems()}
        </div>
      </div>
    </div>
  );
};

export default Ticker;